import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import config from '@/config';

export default Vue => {
    const { sentryDsn: dsn } = config;

    if (!dsn) {
        return;
    }

    Sentry.init({
        dsn,
        integrations: [new Integrations.Vue({ Vue, attachProps: true })]
    });
};
